import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import { useRouter } from 'next/router'
import {
  Category,
  Footer,
  Header,
  TryEdworking,
  EdworkingPromotion,
  Pagination,
  TopBanner,
} from '../../js/components'
import Link from 'next/link'
import Image from 'next/image'
import { OrganizationSchema, WebPageSchema, BreadcrumbListSchema } from '../../js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks

export async function getStaticProps({ locale, locales }) {
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'guides.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  const res1 = await fetch(process.env.NEXT_PUBLIC_VENUSAUR, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      operationName: 'GetGuidesLanding',
      query: `query GetGuidesLanding($language: String) {getGuidesLanding(language: $language){id rawTitle color language title category cover resume author { firstname lastname } createdAt}}`,
      variables: { language: locale },
    }),
  })
  const data = await res1.json()
  const blogs = data.data.getGuidesLanding
  return {
    props: { content, locale, locales, blogs },
  }
}

export default function Guides({ content, locale, locales, blogs }) {
  const edworking = blogs.filter((b) => b.category === 'edworking')
  const guides = blogs.filter((b) => b.category === 'guides')
  const classics = blogs.filter((b) => b.category !== 'edworking' && b.category !== 'guides')

  const [promotion, setPromotion] = useState(false)
  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }
  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema name={content.head.title} description={content.head.description} />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Guides',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}guides`,
          },
        ]}
      />
      <Head>
        <title>{content.head.title}</title>
        <meta itemProp="name" content={content.head.title} />
        <meta itemProp="description" content={content.head.description} />
        <meta name="description" content={content.head.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}/guides`}
          />
        ))}
        <link rel="alternate" href={`https://edworking.com/guides`} hrefLang="x-default" />
        <link
          rel="canonical"
          href={`https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}guides`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header content={content.header} topbanner={true} />
      <Introguides content={content.introguides} />
      <Category
        pagination={true}
        empty={content.empty}
        category={'guides'}
        articles={guides}
      />
      <Category
        pagination={false}
        empty={content.empty}
        category={'edworking'}
        articles={edworking}
      />
      <Category
        pagination={false}
        empty={content.empty}
        category={'startups'}
        articles={classics}
      />
      <TryEdworking content={content.endbanner} language={locale} />
      <Footer content={content.footer} language={locale} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}
/*
export const GuidesSection = ({ guidesBasics, category, locale }) => {
  return (
    <section className="similararticles">
      <div className={`sectiontop ${category}`}>
        <span className="title">{category}</span>
      </div>
      <div className="articles">
        {guidesBasics?.map((guide, index) =>
          <Link key={index} className="single" href={`/blog/guides/${guide.title}`}>
            <Image width={250} height={170} className="cover" src={guide.cover} alt="Cover" />
            <h2 className="title" >{guide.metaTitle}</h2>
            <span className="resume">{guide.resume}</span>
          </Link>
        )}
        <Pagination locale={locale} category={'guides'} />
      </div>
    </section>
  )
}*/
export const Index = ({ language, titles }) => {
  var content = Array.from(titles)

  const [clicked, setClicked] = useState('')
  const [scrolled, setScrolled] = useState('')

  function onClick(c) {
    c.scrollIntoView({ block: 'start', behavior: 'smooth' })
    setClicked(c.innerText)
    setTimeout(() => {
      setClicked('')
    }, 1200)
  }

  window.onscroll = function onScroll() {
    const off = content?.map((c) => {
      const offset = c.getBoundingClientRect().top // - c.offsetTop
      if (offset < 200) {
        setScrolled(c.innerText)
      }
      return offset
    })
  }

  const title = content?.map((c, index) => {
    return (
      <div key={index} className="clickable" onClick={() => onClick(c)}>
        {(clicked === c.innerText || (clicked === '' && scrolled === c.innerText)) && (
          <div className="bar"></div>
        )}
        <h4
          className="element"
          style={{
            color:
              clicked === c.innerText
                ? '#16ccf0'
                : clicked === '' && scrolled === c.innerText
                  ? '#16ccf0'
                  : '#09323A',
          }}
        >
          {c.innerText}
        </h4>
      </div>
    )
  })

  return (
    <div className="index" style={{ marginBottom: 140 }}>
      <h1 className="title">
        {language === 'es'
          ? 'En esta guía'
          : language === 'it'
            ? 'In questa guida'
            : language === 'fr'
              ? 'Dans ce guide'
              : language === 'pt'
                ? 'Neste guia'
                : language === 'de'
                  ? 'In dieser Anleitung'
                  : 'In this guide'}
      </h1>

      <div className="elements">{title}</div>
    </div>
  )
}

const Introguides = ({ content }) => {
  return (
    <section className="introguides">
      <Image
        width={1000}
        height={229}
        src={'/images/Welcome2.png'}
        style={{ height: 'auto' }}
        alt=""
      />
      <h1 className="text">
        <span className="title">
          {content.title1}
          <span style={{ color: '#02bcea' }}>{content.title2}</span>
          {content.title3}
        </span>
        <span className="description">{content.description}</span>
      </h1>
    </section>
  )
}
